import { DatePipe } from "@angular/common";
import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  TemplateRef,
  ViewChild,
} from "@angular/core";
import { FormControl } from "@angular/forms";
import { Store } from "@ngrx/store";
import { ToasterService } from "angular2-toaster";
import swal from "sweetalert2";
import * as fromRootStore from "../../../../reducers";
import { Combo2Service, WorkOrderService } from "../../../../services/index";
import { BsModalRef, BsModalService } from "ngx-bootstrap";
import { ocrPrint } from "./ocrPrint";

declare var google;

@Component({
  selector: "purchaseOrder",
  host: { "(window:keydown)": "hotkeys($event)" },
  templateUrl: "./woDelFmApproval.html",
})
export class woDelFmApproval implements OnInit {
  @Input("tabTitle") title: string;
  @Input("tabID") tabID: string;
  @Input("params") params: any;
  @Input() active = false;
  @Input() dataContext;
  @Output() tabUpdateEvent = new EventEmitter();

  verifierId: number;
  verifier: string;
  cancelWo_no: string;
  seasonList = [];
  gridOptions: any;
  dataList = [];
  approver: string;
  isLoadMask: Promise<any>;
  selectedDlrMapList: any[];
  loadingIndicator: boolean = true;
  reorderable: boolean = true;

  groupbyList = ["RETAIL", "WHOLESALE", "ESTIMATE"];
  filter = {
    shirt_design: "",
    wo_no: "",
    order_from_date: "",
    order_to_date: "",
    wo_from_date: "",
    wo_to_date: "",
    fab_design: "",
    status: "ALL",
    approved: "FM NOT APPROVED",
  };
  page = {
    limit: 100,
    count: 0,
    offset: 0,
    orderBy: "rgrn_no",
    orderDir: "ASC",
  };
  finyearList = [];
  agentList = [];
  seasonfinList = [];
  partyAgentList = [];
  partyList = [];
  approvedList = ["FM APPROVED", "FM NOT APPROVED"];

  @ViewChild("snoTemplate") snoTemplate: TemplateRef<any>;
  @ViewChild("nameTemplate") nameTemplate: TemplateRef<any>;
  @ViewChild("addrTemplate") addrTemplate: TemplateRef<any>;
  @ViewChild("editDeleteTemplate") editDeleteTemplate: TemplateRef<any>;
  @ViewChild("filterPanel") filterPanel;
  @ViewChild("partyDataTable") partyDataTable;
  @ViewChild("printTemplate") printTemplate;
  @ViewChild("cancelTemplate") cancelTemplate;
  @ViewChild("approveTemplate") approveTemplate;

  finyearCtrl: FormControl = new FormControl();
  seasonCtrl: FormControl = new FormControl();
  agentCtrl: FormControl = new FormControl();
  partyCtrl: FormControl = new FormControl();
  groupCtrl: FormControl = new FormControl();
  columns = [];
  toggleCol = [];
  menu: any;
  reportName = "design_no";
  reportType = "Design";
  filterExpand = false;
  filterData: any;
  agentList$ = [];
  user: any;
  agentVisible: boolean = false;
  companyInfo: any = [];
  orderList: any = [];
  constructor(
    public store: Store<fromRootStore.State>,
    public datePipe: DatePipe,
    private combo2Service: Combo2Service,
    private woservice: WorkOrderService,
    public toasterService: ToasterService,
    private modalService: BsModalService
  ) {}

  ngOnInit(): void {
    this.getColumns();
    this.toggleCol = Object.assign({}, this.columns);
  }

  hotkeys(event) {
    if (this.active) {
    }
  }

  getColumns() {
    this.columns = [
      {
        name: "SNo",
        prop: "sno",
        minWidth: 50,
        maxWidth: 50,
        width: 50,
        headerClass: "text-center",
        sortable: false,
        cellTemplate: this.snoTemplate,
        toggle: true,
        cellClass: "text-center",
      },
      {
        name: "Del.Date",
        prop: "del_date",
        cellClass: "text-center",
        headerClass: "text-center",
        minWidth: 100,
        maxWidth: 100,
        width: 100,
      },

      {
        name: "Wo.No",
        prop: "wo_no",
        cellClass: "text-center",
        headerClass: "text-center",
        minWidth: 80,
        maxWidth: 80,
        width: 80,
      },
      {
        name: "Wo.Date",
        prop: "fdate",
        cellClass: "text-center",
        headerClass: "text-center",
        minWidth: 90,
        maxWidth: 90,
        width: 90,
      },
      {
        name: "Wo.qty",
        prop: "wo_qty",
        cellClass: "text-center",
        headerClass: "text-center",
        minWidth: 60,
        maxWidth: 60,
        width: 60,
      },
      {
        name: "Style",
        prop: "style",
        cellClass: "text-center",
        headerClass: "text-center",
        minWidth: 80,
        maxWidth: 80,
        width: 80,
      },

     {
        name: "Variety",
        prop: "type",
        cellClass: "text-center",
        headerClass: "text-center",
        minWidth: 80,
        maxWidth: 80,
        width: 80,
      },  
       {
        name: "Shirt.No",
        prop: "shirt_design_no",
        cellClass: "text-center",
        headerClass: "text-center",
        minWidth: 80,
        maxWidth: 80,
        width: 80,
      },
      {
        name: "Tot.Clrs",
        prop: "shades",
        cellClass: "text-center",
        headerClass: "text-center",
        minWidth: 60,
        maxWidth: 60,
        width: 60,
      },
      {
        name: "Width",
        prop: "width",
        headerClass: "text-center",
        minWidth: 60,
        maxWidth: 60,
        width: 60,
      },
      {
        name: "Tot.Mtrs",
        prop: "wo_mtrs",
        cellClass: "text-center",
        headerClass: "text-center",
        minWidth: 60,
        maxWidth: 60,
        width: 60,
      },
      {
        name: "Wo.Ratio",
        prop: "wo_cons",
        headerClass: "text-center",
        cellClass: "text-center",
        minWidth: 90,
        maxWidth: 90,
        width: 90,
      },
      {
        name: "Ac.Ratio",
        prop: "ac_cons",
        headerClass: "text-center",
        cellClass: "text-center",
        minWidth: 90,
        maxWidth: 90,
        width: 90,
      },


      {
        name: "Act.F/S",
        prop: "ac_ftot",
        cellClass: "text-center",
        headerClass: "text-center",
        minWidth: 60,
        maxWidth: 60,
        width: 60,
      },
      {
        name: "Ac.H/S",
        prop: "ac_htot",
        headerClass: "text-center",
        minWidth: 60,
        maxWidth: 60,
        width: 60,
      },
      {
        name: "Tot.Qty",
        prop: "ac_qty",
        headerClass: "text-center",
        minWidth: 60,
        maxWidth: 60,
        width: 60,
      },
      {
        name: "Cu.No",
        prop: "cu_no",
        cellClass: "text-center",
        headerClass: "text-center",
        minWidth: 60,
        maxWidth: 60,
        width: 60,
      },
      {
        name: "Del.F/S",
        prop: "rftot",
        headerClass: "text-center",
        minWidth: 60,
        maxWidth: 60,
        width: 60,
      },
      {
        name: "Del.H/S",
        prop: "rhtot",
        headerClass: "text-center",
        minWidth: 60,
        maxWidth: 60,
        width: 60,
      },
      {
        name: "Can.\nPcs",
        prop: "del_can_qty",
        headerClass: "text-center",
        minWidth: 60,
        maxWidth: 60,
        width: 60,
      },
      {
        name: "Dam.\nPcs",
        prop: "del_dam_qty",
        headerClass: "text-center",
        minWidth: 60,
        maxWidth: 60,
        width: 60,
      },
      {
        name: "Tot.Qty",
        prop: "delivery_qty",
        headerClass: "text-center",
        minWidth: 60,
        maxWidth: 60,
        width: 60,
      },
      {
        name: "Avg.\nCons",
        prop: "avg_cons",
        headerClass: "text-center",
        minWidth: 60,
        maxWidth: 60,
        width: 60,
      },
      {
        name: "Age",
        prop: "age",
        headerClass: "text-center",
        minWidth: 60,
        maxWidth: 60,
        width: 60,
      },
      {
        name: "Bal.Bit",
        prop: "rbalmtrs",
        headerClass: "text-center",
        minWidth: 60,
        maxWidth: 60,
        width: 60,
      },
      {
        name: "Production Status",
        prop: "production_status",
        headerClass: "text-center",
        cellClass: "text-center",
        minWidth: 120,
        maxWidth: 120,
        width: 120,
      },
      {
        name: "Action",
        prop: "sno",
        minWidth: 100,
        maxWidth: 120,
        width: 110,
        sortable: false,
        cellTemplate: this.editDeleteTemplate,
      },
      // {
      //   name: "Approve",
      //   prop: "sno",
      //   minWidth: 80,
      //   maxWidth: 120,
      //   width: 80,
      //   sortable: false,
      //   cellTemplate: this.approveTemplate,
      // },
    ];
    this.toggleCol = Object.assign({}, this.columns);

    this.pageCallback({ offset: 0 });
  }

  onOpenedFilter(): void {
    setTimeout(function () {
      $("#party_code").focus();
    }, 100);
  }

  onChangePageSize(limit) {
    this.page.limit = 10000;
    //this.getSalesinvReport();
  }

  onColumnToggle(colToShow) {
    this.columns = colToShow;
  }

  onEnterKeyPressed(nextEl: string, ind, item) {
    if ($(".swal2-container").length > 0) {
      return false;
    } else {
      let a = $(".mat-autocomplete-panel.mat-autocomplete-visible");
      a.removeClass("mat-autocomplete-visible");
      $("#" + nextEl).focus();
    }
  }

  getRowClass(event) {
    return event.rowtype == "summary" ? "summary-row" : "";
  }

  /**
   * Called whenever the user changes page
   */
  pageCallback(pageInfo: {
    count?: number;
    pageSize?: number;
    limit?: number;
    offset?: number;
  }) {
    this.page.offset = pageInfo.offset;
    this.getOrderList();
  }

  /**
   * Called whenever the user changes the sort order
   */
  sortCallback(sortInfo: {
    sorts: { dir: string; prop: string }[];
    column: {};
    prevValue: string;
    newValue: string;
  }) {
    // there will always be one "sort" object if "sortType" is set to "single"
    this.page.orderDir = sortInfo.sorts[0].dir;
    this.page.orderBy = sortInfo.sorts[0].prop;
    // this.getSalesinvReport();
  }

  clearFilter(): void {
    this.filter.shirt_design = "";
    this.filter.wo_no = "";
    this.filter.order_from_date = "";
    this.filter.order_to_date = "";
    this.filter.wo_from_date = "";
    this.filter.wo_to_date = "";
    this.filter.fab_design = "";
    this.filter.status = "";
    this.applyFilter();
  }

  applyFilter(): void {
    //this.filterExpand = false;
    this.filterPanel.close();
    this.getOrderList();
  }

  loadSeasonList() {
    let that = this;
    this.combo2Service.seasonCombo().then(function (res) {
      //  this.LoadAgentList();
      that.seasonList = res.data;
      that.seasonCtrl.setValue(res.data[0].season_id);
    });
  }

  addEditPO(mode: string, row: any): void {
    let listUpdateEvent = new EventEmitter();
    listUpdateEvent.subscribe(() => {
      this.getOrderList();
    });
    row.tabevent = listUpdateEvent;
    let tabObj = {};
    if (mode == "View") {
      tabObj = {
        action: "NewTab",
        params: {
          //   tabParent: 'Transaction',
          tabName: "VIEW OCR ENTRY",
          title: "VIEW OCR ENTRY",
          tabParent: "PURCHASE",
          mode: mode,
          from_page: "FM Approval",
          data: row,
          name: "VIEW OCR ENTRY",
        },
      };
    }

    this.tabUpdateEvent.emit(tabObj);
  }

  getOrderList(): void {
    if (this.filter.wo_from_date !== "") {
      this.filter.wo_from_date = this.datePipe.transform(
        this.filter.wo_from_date,
        "yyyy-MM-dd"
      );
    }
    if (this.filter.wo_to_date !== "") {
      this.filter.wo_to_date = this.datePipe.transform(
        this.filter.wo_to_date,
        "yyyy-MM-dd"
      );
    }
    let params = {
      start: `${this.page.offset * (this.page.limit + 1)}`,
      limit: `${this.page.limit}`,
      page: "1",
      orderColumn: `${this.page.orderBy}`,
      orderDir: `${this.page.orderDir}`,
      shirt_design: this.filter.shirt_design,
      wo_no: this.filter.wo_no,
      wo_from_date: this.filter.wo_from_date,
      wo_to_date: this.filter.wo_to_date,
      fab_design: this.filter.fab_design,
      status: this.filter.status,
      verifiedby: "NOT NULL",
      approved: this.filter.approved,
      production_status: "FM APPROVAL",
      //order_from_date:this.filter.order_from_date
    };
    let that = this;
    //this.store.dispatch(new commonActions.LoadAllParty(params));
    this.isLoadMask = this.woservice
      .getOrderListFmRdApproval(params)
      .then(function (res: any) {
        that.loadingIndicator = false;
        that.page.count = res.totCnt;
        that.orderList = res.data;
        that.orderList.forEach(e => {
          e.delivery_qty = Number(e.del_can_qty) + Number(e.del_dam_qty) + Number(e.del_tot)
        });
      });
  }

  // approval(row) {
  //   let that = this;
  //   swal({
  //     title: "Are you sure to Approve this Order (" + row["wo_no"] + ") ?",
  //     html:
  //       '<input type = "text" id="approver" class="swal2-input" placeholder = "APPROVER">',
  //     type: "warning",
  //     showCancelButton: true,
  //     confirmButtonText: "Yes, Approve it!",
  //     cancelButtonText: "Cancel",
  //   }).then(
  //     function () {
  //       if (
  //         (<HTMLInputElement>document.getElementById("approver")).value != ""
  //       ) {
  //         let params = {
  //           wo_id: row.wo_id,
  //           wd_id: row.rgrn_id,
  //           approver: (<HTMLInputElement>document.getElementById("approver"))
  //             .value,
  //         };
  //         that.isLoadMask = that.woservice
  //           .approveOrderFm(params)
  //           .then((res: any) => {
  //             swal("Approved by FM Successfully");
  //             setTimeout(() => {
  //               swal({
  //                 title: "Do you need a OCR print?",
  //                 type: "warning",
  //                 showCancelButton: true,
  //                 confirmButtonText: "Yes, Print!",
  //                 cancelButtonText: "No",
  //               }).then(() => {
  //                 that.print(row);
  //               });
  //             }, 2000);
  //             that.getOrderList();
  //           });
  //       } else {
  //         swal("PLEASE ENTER APPROVER NAME");
  //       }
  //     },
  //     function (dismiss) {}
  //   );
  // }
  bsModalRef: BsModalRef;
  print(row) {
    this.bsModalRef = this.modalService.show(ocrPrint, {
      keyboard: false,
      ignoreBackdropClick: true,
      class: "modal-lg compWidth-96",
    });
    this.bsModalRef.content.printdt = Object.assign({}, row);
    // this.bsModalRef.content.printcontent = this.printData;
  }
}



// WEBPACK FOOTER //
// /Users/afsarahamed/Documents/symatis/projects/hyatt-angularweb/src/app/components/Purchase/workorder/woDelFmApproval/woDelFmApproval.ts